<template>

    <div class="wrap viewport">
		<!-- header 공통 부분 시작 -->
		<!--
		<at-header
			:isModal="true"
			:isTitle="true"
			titleName="전자영수증"
			v-on:close="loginAction"
			></at-header>
		-->
		<!-- header 공통 부분 끝 -->
        <div class="container">
			<div class="error_wrap">
                <div class="error">
                    <div class="tit">서비스 이용에<br />불편을 드려 죄송합니다.</div>
                    <p class="txt">세션이 만료되었습니다.<br />다시 로그인해주세요.</p>
                </div>
            </div><!-- // general_wrap -->
        </div><!-- // container -->

      <!--kt 인터페이스 로그인-->
      <at-button :btnName="`로그인`"
                 :btnClass="`f_btn_group`"
                 :btnEvent="`login`"
                 v-if='"ktt" === telcoAgency'
                 v-on:login="fnRequestLogin">
      </at-button>

      <!--Legacy/데모앱/SKT/LGUP 로그인-->
      <at-button :btnName="`로그인`"
        :btnClass="`f_btn_group`"
        :btnEvent="`login`"
        v-else
        v-on:login="loginAction">
      </at-button>

    </div>
    <!-- // wrap -->

</template>

<script>
export default {
  data() {
    return {
      // 통신사별 root path
      baseUrl: process.env.BASE_URL,
      // 통신사별 image resource path
      resPath: process.env.VUE_APP_RESOURCE_PATH,
      // 통신사 코드
      telcoAgency: process.env.VUE_APP_AGENCY
    };
  },
  created() {
    var localThis = this;

		window.loginCallbak = result => {
      if(true == result.header.isSuccess || "true" == result.header.isSuccess){
        let mainUrl = this.$data.baseUrl + "main/P000001"; //해지 완료 시 이동할 가입 페이지 
        document.location.href = mainUrl;
        //history.back();
      }
    }

    //KT
		if("ktt" === this.$data.telcoAgency) {
			window.onClickTitleCloseBtn = function() { 
				let data = {};
				let action = "requestWebViewFinish"; 
        let callbackFn = "";
        
        this.fnCallInterface(data, action, callbackFn);
      };
     
    }
    
	},
  methods : {
    /* Legacy/SKT/LGT/데모 인터페이스 호출 */
		loginAction() {
			let data = {};
			let action = "login";
			let callbackFn = "loginCallbak";
			this.fnCallInterface(data, action, callbackFn);
		},
		/* KT PASS앱 인터페이스 호출 */
		fnRequestLogin(){
			let data = {};
			let action = "requestLogin"; 
			let callbackFn = "";
			this.fnCallInterface(data, action, callbackFn);
    }
	}
}
</script>

<style>

</style>
